module.exports = "/_next/static/images/ada-6f726f487d684a9aa58bc9a585005968.svg";